import { useEffect, useState } from 'react';

const PermissionOfMenus = ({
	allowedPermission,
	children,
	checkType = 'SINGLE',
	allowedMultiPermissions = [],
	isRequestForMoreMenu = false
}) => {
	const [menuPermissions, setMenuPermissions] = useState([]);
	const [moreMenuPermissions, setMoreMenuPermissions] = useState([]);

	useEffect(() => {
		let userInfo = localStorage.getItem('userInfo');
		if (userInfo) {
			userInfo = JSON.parse(userInfo);
			setMenuPermissions([...(userInfo?.mainMenus || [])]);
			setMoreMenuPermissions([...(userInfo?.moreMenus || [])]);
		}
	}, []);

	if (checkType === 'MULTIPLE') {
		const couldShow = allowedMultiPermissions.every((permission) =>
			isRequestForMoreMenu
				? moreMenuPermissions.includes(permission)
				: menuPermissions.includes(permission)
		);
		return couldShow ? children : null;
	} else {
		const couldShow = isRequestForMoreMenu
			? moreMenuPermissions.includes(allowedPermission)
			: menuPermissions.includes(allowedPermission);
		return couldShow ? children : null;
	}
};

export default PermissionOfMenus;
